webpackJsonp([16],{

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCadCliente_vue__ = __webpack_require__(498);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_977ef674_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCadCliente_vue__ = __webpack_require__(537);
function injectStyle (ssrContext) {
  __webpack_require__(535)
}
var normalizeComponent = __webpack_require__(103)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCadCliente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_977ef674_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCadCliente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_http_axios__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_format__ = __webpack_require__(440);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var moment = __webpack_require__(315);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FormCadCliente",
  props: ["dialog"],
  mixins: [__WEBPACK_IMPORTED_MODULE_2__services_format__["a" /* formata */]],

  data: function data() {
    return {
      loader: null,
      loadingBtn: false,
      cliente: {
        nome: "",
        cpf: "",
        email: "",
        telefone: "",
        data_nascimento: "",
        cnpj_origem: window.sessionStorage.getItem("cnpj")
      },
      menu: false,
      dataFim: moment().format("YYYY-MM-DD"),
      dataFimFormatted: "",
      alterar: "",
      nomeRules: [function (v) {
        return !!v || "Nome é requerido";
      }],
      telRules: [function (v) {
        return !!v || "Telefone é requerido";
      }],
      emailRules: [function (v) {
        return !!v || "email é requerido";
      }],
      cpfRules: [function (v) {
        return !!v || "Cpf é requerido";
      }, function (v) {
        return v.length == 11 || "Cpf   Menor que o padrão";
      }]
    };
  },
  mounted: function mounted() {
    //alert(this.dados);
  },

  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.dataIn);
    }
  },

  watch: {
    dataFimFormatted: function dataFimFormatted(val) {
      if (val == null) {
        this.cliente.data_nascimento = "";
      }
    },
    menu: function menu(val) {
      var _this = this;

      val && this.$nextTick(function () {
        return _this.$refs.picker.activePicker = "YEAR";
      });
    },

    /*dados(val) {
      if (val) {
        this.convenio.nome = val.nome;
        this.convenio.cnpj = val.cnpj;
        this.convenio.descricao = val.descricao;
        this.convenio.id = val.id;
        this.alterar = "Alterar ";
      } else {
        this.convenio.id = "";
        this.alterar = "";
      }
    },*/
    dataIn: function dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
    },
    dataFim: function dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
    }
  },

  methods: {
    save: function save(data) {
      console.log(data);
      this.cliente.data_nascimento = this.parseDate(this.dataFimFormatted);
    },
    getErroCadCliente: function getErroCadCliente(texto) {
      this.textSnack = texto;
      this.snackbar = true;
    },
    salvar: function salvar() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_http_axios__["a" /* HTTP */].post("cliente/precadastro_retaguarda", this.cliente).then(function (response) {
        if (response.data.error) {
          alert("erros:");
        }
        _this2.cliente.cpf = "";
        _this2.cliente.nome = "";
        _this2.cliente.email = "";
        _this2.cliente.telefone = "";
        _this2.cliente.data_nascimento = "";
        _this2.loader = null;
        _this2.loadingBtn = false;
        _this2.$emit("gravacaoOkCliente");
        _this2.$emit("fechaDialog");
        _this2.$emit("MensagemGravaSucesso", "Gravação executado com sucesso!");
      }).catch(function (e) {
        // console.log("erros:::::" + e.response.data.errors);
        console.log(e.response.data.error);
        if (!Array.isArray(e.response.data.error)) {
          var itens = [];
          for (var prop in e.response.data.error) {
            itens.push(e.response.data.error[prop][0]);
          }
          _this2.loadingBtn = false;
          _this2.$emit("getCadCliente", itens.join(","));
        }
      });
      // this.$parent.selDialog = false;
    },
    parente: function parente() {
      this.$emit("fechaDialog");
    },
    checkStatus: function checkStatus(valor) {
      if (valor) {
        return "Ativo";
      } else {
        return "Inativo ";
      }
    },
    filtrar: function filtrar() {
      // this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda: function formata_moeda(val) {
      var val1 = val / 100;
      var valor = this.formatar_moeda(val1);
      return valor;
    },
    buscaConvenios: function buscaConvenios() {
      var _this3 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_http_axios__["a" /* HTTP */].get("grupo/lista/convenio").then(function (response) {
        if (response.data.error) {
          _this3.textSnack = response.data.error;
          _this3.snackbar = true;
        } else {
          //this.extrato =

          _this3.items = response.data;
          _this3.mostraCartoes = true;
        }
        _this3.loading = false;
      });
    },


    //mudar para um mixed
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split("-"),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split("/"),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, "0") + "-" + day.padStart(2, "0");
    }
  }
});

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(536);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(299)("74f92e30", content, true, {});

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(298)(true);
// imports


// module
exports.push([module.i, "#container{margin-top:115px}", "", {"version":3,"sources":["C:/Users/chris/projetos/GrupoPrepago/src/components/FormCadCliente.vue"],"names":[],"mappings":"AACA,WACE,gBAAkB,CACnB","file":"FormCadCliente.vue","sourcesContent":["\n#container {\r\n  margin-top: 115px;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","hide-overlay":"","max-width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.alterar)+" Cliente")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"rules":_vm.nomeRules,"label":"Nome","required":""},model:{value:(_vm.cliente.nome),callback:function ($$v) {_vm.$set(_vm.cliente, "nome", $$v)},expression:"cliente.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"rules":_vm.telRules,"hint":"Utilizar somente números ex:3199999999","persistent-hint":"","label":"Telefone","required":""},model:{value:(_vm.cliente.telefone),callback:function ($$v) {_vm.$set(_vm.cliente, "telefone", $$v)},expression:"cliente.telefone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Cpf","mask":"###########","rules":_vm.cpfRules,"counter":"11","hint":"utiliza somente números","required":""},model:{value:(_vm.cliente.cpf),callback:function ($$v) {_vm.$set(_vm.cliente, "cpf", $$v)},expression:"cliente.cpf"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"rules":_vm.emailRules,"name":"email","label":"Email","value":""},model:{value:(_vm.cliente.email),callback:function ($$v) {_vm.$set(_vm.cliente, "email", $$v)},expression:"cliente.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":170,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","outline":"","label":"Data Nascimento","readonly":"","persistent-hint":"","prepend-icon":"event","required":"","clearable":""},slot:"activator",model:{value:(_vm.dataFimFormatted),callback:function ($$v) {_vm.dataFimFormatted=$$v},expression:"dataFimFormatted"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"locale":"pt-br","no-title":"","max":new Date().toISOString().substr(0, 10),"min":"1930-01-01"},on:{"change":_vm.save,"input":function($event){_vm.menu = false}},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}})],1)],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*Campos requeridos")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"terciary"},nativeOn:{"click":function($event){_vm.parente()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"loading":_vm.loadingBtn,"disabled":_vm.loadingBtn,"color":"sucesso"},nativeOn:{"click":function($event){_vm.salvar();_vm.loadingBtn=true;_vm.loader = 'loadingBtn'}}},[_vm._v("Gravar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/16.9bc8a060b0b754e664a0.js